import type {ReactElement, RefObject} from 'react';
import type {AiPromptBox, SelectedContextualMenuItems} from '@Components/ai-prompt-box/ai-prompt-box.types';
import type {FooterLeftAction} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {GenerateIdeasOriginator} from '@Libraries/ai-email-campaign-content-library';
import type {PopoverDefaultAlignment} from '@Components/popover/popover.types';

export enum AiWriterType {
  POPOVER = 'popover',
  PANEL = 'panel',
}

export interface AiWriterSource<T> {
  id: string;
  sessionStorageKey: string;
  initialConfig: AiPromptBox;
  options: FooterLeftAction[];
  fetchRecents: () => Promise<T[]>;
  onGenerate: (prompt: string, options: SelectedContextualMenuItems, originator: GenerateIdeasOriginator) => Promise<T[]>;
  onItemSelect: (item: T, prompt: string) => void;
  getItemKey: (item: T) => string;
  renderItem?: (item: T) => ReactElement;
  aiPromptBoxPreviewText?: string;
  title: string;
  showRetryOnError?: boolean;
}

export interface AiWriterProps<T> {
  displayType: AiWriterType;
  source: AiWriterSource<T>;
  className?: string;
  closeOnItemSelect?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
  onClose?: () => void;
  isOpenedInPopOver?: boolean;
  alignment?: PopoverDefaultAlignment;
  referenceElementRef?: RefObject<HTMLButtonElement | null>;
  isOpen?: boolean;
}
